export const channelFields = [
  {
    name: "channel_Id",
    label: "Channel ID",
    type: "text",
    required: true,
  },
  {
    name: "channel_Name",
    label: "Channel Name",
    type: "text",
    required: true,
  },
  {
    name: "channel_Type",
    label: "Channel Type",
    type: "select",
    required: true,
  },
  {
    name: "channel_Link",
    label: "Channel Link",
    type: "text",
    required: true,
  },
 
  {
    name: "apiUrl",
    label: "API Url",
    type: "array",
    required: true,
  },

];

